<template>
<span>

  <big
    :item-reason="itemReason"
    :row-type="itemType"
    :all-prizes="allPrizes"
    :story-header="storyHeader"
  ></big>

  <v-data-table
    :items="details"
    hide-default-footer
    hide-default-header
    :headers="headers"
    :items-per-page="(details && details.length) || 10"
  >
    <template v-slot:item="{item}">
      <tr>
        <td v-if="imageColumn || item.image">
          <image-icon 
            v-if="item.avatar" 
            :image="item.image" 
            :itemType="itemType" 
            :width="width" 
            avatar
          ></image-icon>
        </td>
        <td v-else class="font-weight-light" style="width:25%;">{{ item.label }}</td>
        <td><a v-if="item.type==='url'" :href="makeUrl(item.value)" target="_blank">{{item.label}}</a><span v-else>{{ item.value }}</span></td>
      </tr>
    </template>
  </v-data-table>
</span>
</template>
<script>
import { SearchUtils } from '@/js'
import Imageicon from '@/components/Imageicon'
import Big from '@/components/Big'
import { settings } from '@/js/store'
import { fieldDetails } from '@/js/fielddetails'
import pluckDeep from 'pluck-deep'
export default {
  name: 'Detailtable',
  components: {
    'image-icon': Imageicon,
    'big': Big
  },
  props: {
    source: Object,
    itemType: String,
    imageColumn: Boolean,
    itemReason: Object,
    allPrizes: Object,
    storyHeader: Object
  },
  methods: {
    makeUrl (str) {
      return str.match(/^http[s]?:\/\//,'i') ? str : 'https://' + str
    },
    getRowOb (row) {
      // fills in the defaults for a row field detail
      return typeof row === 'string'
        ? {
          property: row,
          label: SearchUtils.unCamel({ text: row, capAll: true })
        }
        : {
          ...row,
          label: row.label || SearchUtils.unCamel({ text: row.property, capAll: true })
        }
    },
    getValues ({ row, source }) {

      const plucked = pluckDeep (source, row.property)
      if(!plucked) return null;

      // consistenyly make it an array
      const item = Array.isArray(plucked) ? plucked : [plucked]

      return item.map(f=> {
        // simple properties
        if (!row.type || row.type === 'url') {
          return f
        }
        // pluck out the localized name
        if(row.type === 'localized') {
          return this.localize({item:f})
        } else if (row.type === 'treeLocalized') {
          return this.treeLocalize({item:f, row})
        } else if (row.type === 'tree') {
          return this.tree ({item:f, row})
        } else if (row.type === 'date') {
          const dt = SearchUtils.formatDate(f)
          return dt === 'Invalid date' ? null : dt
        } else {
        console.log('invalid row type', row, item)
        }

      })
      .filter(f=>f)
      .join(" | ") || null
      
    },
    getTypeName ({item}) {
      const tp = item && item.__typename
      if(!tp) {
        console.log('failed to find typename for ', item)
        return null
      }
      return tp;
    },
    treeLocalize ({item, row}) {
      const tp = this.getTypeName({item})
      return tp && (SearchUtils.treeUntangle({ item, keepOrder: row.keepOrder, separator: ', ', localizedKey: tp + 'Localized' }) ||
          SearchUtils.treeUntangle({ item, keepOrder: row.keepOrder, separator: ', ', localizedKey: tp + 'Localised' }))
    },
    tree ({item, row}) {
      return SearchUtils.treeUntangle({ item, keepOrder: row.keepOrder, separator: ', ' })
    },
    localize ({item}) {
      const tp = this.getTypeName({item})
      return tp && (pluckDeep(item, tp + 'Localized.name') || pluckDeep( item, tp + 'Localised.name'))
      
    },

    getImage ({ source }) {
      // gets the image for this type of item
      // need to generate a reason .. we can use the typename from apollo
      if (!source.__typename) {
        console.log('missing typename from', JSON.stringify(source))
        return ''
      } else {
        const reason = {}
        reason[source.__typename] = source
        return SearchUtils.getImageFromReason({
          reason,
          rowType: this.itemType,
          minHeight: settings.dimensions.posterFrameHeight
        })
      }
    }
  },
  computed: {
    headers () {
     const headers = this.imageColumn ? [{ value: 'image', text: 'image' }] : []
     return headers.concat([{ value: 'label', text: 'label' }, { value: 'value', text: 'value' }])
    },
    width () {
      return 25
    },
    details () {
      // get the label and value from a data object
      const { source } = this

      const result =  fieldDetails[this.itemType].fields.map(f => {
        // fill in the blanks in the row definition
        const row = this.getRowOb(f)
        // now get the label and value if there's any data
        if (source) {
          const values = this.getValues({ row, source });
          return values ? {
            label: row.label,
            value: this.getValues({ row, source }),
            image: row.avatar && this.getImage({ row, source }),
            avatar: row.avatar,
            type: row.type
          } : null
        }
      }).filter(f => f)
      
      return result
    }
  }
}
</script>
